import React from 'react'
import { Provider } from 'react-redux'
import { CssBaseline, ThemeProvider } from '@mui/material'
import ReactDOM from 'react-dom/client'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import { NuqsAdapter } from 'nuqs/adapters/react'
import { HelmetProvider } from 'react-helmet-async'
import theme from 'theme'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { store } from './store/api.store'

import './font.scss'
import './index.scss'

const persistor = persistStore(store)
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <HelmetProvider>
            <NuqsAdapter>
              <App />
            </NuqsAdapter>
          </HelmetProvider>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
